import Reflux from 'reflux';
import CuesheetTransientCellActions from 'flux/actions/cuesheet/CuesheetTransientCellActions';
import BaseMixin from 'flux/stores/BaseMixin';

/**
 * CuesheetTransientCellActions...keep transient cell changes in memory
 *
 */
export default Reflux.createStore({
  listenables: [CuesheetTransientCellActions],

  mixins: [BaseMixin],

  init() {
    this.setState(null);
  },

  onSetTransientCellValue(value) {
    this.setStateAndTrigger(value);
  },

  onClearTransientCellValue() {
    this.setStateAndTrigger(null);
  },
});
